import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { PrimaryButton } from "components/Button/PrimaryButton";
import { PlanBadge, Plan } from "pages/Backoffice/TEST/PlanSelection";
import { useSubscription } from "hooks/useStripe";
import { getRelativeTimeFuture } from "utils/date";

export const BillingTab = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { subscription, uiState } = useSubscription();

  const isInTrailPeriod =
    (subscription?.trailEnd || 0) * 1000 > Date.now();

  return (
    <div className="">
      <div>
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          {t("settings.billing.title")}{" "}
          {subscription?.plan && (
            <PlanBadge plan={subscription.plan as unknown as Plan} />
          )}
        </h3>
        <p className="mt-1 max-w-2xl text-sm text-gray-500">
          {t("settings.billing.title")}
        </p>
      </div>
      <dl className="">
        <div className="grid grid-cols-3 gap-x-4 gap-y-8 sm:grid-cols-3">
          <div className="sm:col-span-1">
            <dt className="text-sm font-medium text-gray-500">
              {t("settings.billing.plan_label")}
            </dt>
            <dd className="mt-1 text-sm text-gray-900">
              {subscription?.plan}
            </dd>
          </div>
          <div className="sm:col-span-1">
            <dt className="text-sm font-medium text-gray-500">
              {t("settings.billing.frequency_label")}
            </dt>
            <dd className="mt-1 text-sm text-gray-900">
              {subscription?.frequency}
            </dd>
          </div>
          {isInTrailPeriod && (
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">
                {t("settings.billing.trial_label")}
              </dt>
              <dd className="mt-1 text-sm text-gray-900">
                {getRelativeTimeFuture(
                  (subscription?.trailEnd || 0) * 1000
                )}
              </dd>
            </div>
          )}
        </div>
      </dl>
      <div className="sm:flex-1 sm:min-w-0 sm:flex sm:items-center sm:justify-end sm:space-x- mt-4">
        <div className="flex flex-col justify-stretch space-y-3 sm:flex-row sm:space-y-0 sm:space-x-2">
          <PrimaryButton
            onClick={() => {
              history.push("/settings/billing");
            }}
          >
            {t("settings.billing.action_manage")}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};
